import script from "./game-over.vue?vue&type=script&setup=true&lang=ts"
export * from "./game-over.vue?vue&type=script&setup=true&lang=ts"

import "./game-over.vue?vue&type=style&index=0&id=dbc421e2&lang=scss"

const __exports__ = script;

export default __exports__